"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var StreamFileStore = /*#__PURE__*/function () {
  function StreamFileStore(client, token) {
    (0, _classCallCheck2.default)(this, StreamFileStore);
    this.client = client;
    this.token = token;
  } // React Native does not auto-detect MIME type, you need to pass that via contentType
  // param. If you don't then Android will refuse to perform the upload


  (0, _createClass2.default)(StreamFileStore, [{
    key: "upload",
    value: function upload(uri, name, contentType, onUploadProgress) {
      /**
       * upload a File instance or a readable stream of data
       * @param {File|Buffer|string} uri - File object or Buffer or URI
       * @param {string} [name] - file name
       * @param {string} [contentType] - mime-type
       * @param {function} [onUploadProgress] - browser only, Function that is called with upload progress
       * @return {Promise}
       */
      return this.client.upload('files/', uri, name, contentType, onUploadProgress);
    }
  }, {
    key: "delete",
    value: function _delete(uri) {
      return this.client.delete({
        url: "files/",
        qs: {
          url: uri
        },
        signature: this.token
      });
    }
  }]);
  return StreamFileStore;
}();

exports.default = StreamFileStore;